import { useEffect, useRef, useState } from 'react';
import useOrg from '@/contexts/OrgContext';

// The Smart Dash is THE admin layout. Tenants only ever get it. Parcelink keeps
// the classic frame as a hidden fallback until it is deleted: ?smartdash=off in
// any admin URL switches to it, ?smartdash=on switches back. Nothing in the
// new frame offers the way out.
const KEY = 'smartdash';
const EVT = 'smartdash:change';

export function readSmartDash(isFlagship = true) {
  if (!isFlagship) return true;
  try {
    const q = new URLSearchParams(window.location.search).get('smartdash');
    if (q === 'on' || q === 'off') window.localStorage.setItem(KEY, q);
    return window.localStorage.getItem(KEY) !== 'off';
  } catch (_e) {
    return true;
  }
}

export function setSmartDash(on) {
  try { window.localStorage.setItem(KEY, on ? 'on' : 'off'); } catch (_e) { /* private mode */ }
  window.dispatchEvent(new Event(EVT));
}

export default function useSmartDash() {
  const { isFlagship, loaded } = useOrg();
  // Until the org first resolves, show the new frame: it is everyone's
  // default, so nobody sees the classic one flash first. After that, keep the
  // last known answer — the org reloads on auth refreshes, and the layout must
  // not swap (and remount every page) while it does.
  const known = useRef(null);
  if (loaded) known.current = isFlagship;
  const flagship = known.current ?? false;
  const [on, setOn] = useState(() => readSmartDash(flagship));
  useEffect(() => {
    const sync = () => setOn(readSmartDash(flagship));
    sync();
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener('storage', sync);
    };
  }, [flagship]);
  return on;
}
